import React, { memo, useContext, useEffect, useRef, useState } from 'react';

import { FiltersContext } from 'context/GlobalFiltersContext';

import { MenuService } from 'services/main/endpoints/MenuService';
import { getLocalAuthStorage } from 'utils/localStorage';
import leankeepLogoCarbon from 'assets/icons/leankeep/leankeep-carbon.svg';
import { Logo, Sidebar, StyledMenuCategory, MenuItems, SidebarContainer } from './styled';
import { CategoryItem } from './subcomponents/CategoryItem';
import jwt from 'jwt-decode';
//import { menuSuperUser } from 'utils/helpers/menuSuperUser';
import { menuAdmin } from 'utils/helpers/menuAdmin';
import { createGenericErrorToast } from 'utils/createToast';
import { usePermissions } from 'hooks/usePermission';
import { Toast } from 'components/Toast';
import { GlobalComponentsContext } from 'context';
import { v4 } from 'uuid';
import * as Sentry from '@sentry/react';
import { useCookies } from 'react-cookie';
export const NewMenu = memo(({ setIsSubMenuOpen }) => {
  const { globalComponentsContext } = useContext(GlobalComponentsContext);
  const { setPermissionContext } = usePermissions();
  const [toastList, setToastList] = useState([]);
  const { headerFiltersContext } = useContext(FiltersContext);
  const { headerFilters } = headerFiltersContext;
  const companyLogoPath = headerFilters?.companies?.logoPath;
  const unitLogoPath = headerFilters?.units?.logoPath;
  const logoPath = unitLogoPath ? unitLogoPath : companyLogoPath;
  const [pages, setPages] = useState({});
  const [adminMenu, setAdminMenu] = useState();
  const { user, token } = getLocalAuthStorage();
  const [cookie] = useCookies();
  const getUserType = () => {
    const { utyp } = jwt(token);
    const tipoUsuario = JSON.parse(utyp);
    return tipoUsuario;
  };

  const menuRef = useRef(null);

  const type = getUserType();
  useEffect(() => {
    Sentry.logger.info('Fetching menu', {
      userId: user?.id,
      empresaId: cookie?.companies?.id,
      empreaName: cookie?.companies?.name,
    });
    MenuService.getUserMenu({
      unidade: type === 1 ? undefined : headerFilters?.units?.id,
      empresa: type === 1 ? undefined : headerFilters?.companies?.id,
    })
      .then(res => {
        switch (type) {
          case 1:
            setAdminMenu(res.data);
            break;
          case 2:
            setAdminMenu(res.data);
            break;
          case 3:
            setAdminMenu(res.data);
            break;
          default:
            setAdminMenu(res.data);
            break;
        }
      })
      .catch(e => {
        createGenericErrorToast(setToastList);
        const capturedError =
          e instanceof Error ? e : new Error(e?.message || e?.statusText || `HTTP ${e?.status ?? 'unknown'}`);
        Sentry.captureException(capturedError, {
          tags: {
            section: 'Menu Fetching',
            userId: user?.id,
            empresaId: cookie?.companies?.id,
            empreaName: cookie?.companies?.name,
          },
        });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.permissionType, headerFilters?.companies?.id, headerFilters?.units?.id]);
  useEffect(() => {
    const isNotSuperUser = type === 2 || type === 3 || type === 4;
    if (isNotSuperUser && adminMenu) {
      setPages(menuAdmin(adminMenu));
      const permissions = handlePermissions(adminMenu, headerFilters?.units?.id);
      if (permissions !== undefined) {
        setPermissionContext(prev => {
          // Remove only the bad key "permissions" that shouldn't exist
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { permissions: _ignored, ...cleanPrev } = prev;

          return {
            ...cleanPrev,
            ...permissions, // apenas home, dashboard, relatorios, etc
          };
        });
      }
    } else if (type === 1 && adminMenu) {
      const unit = type === 1 ? null : headerFilters?.units?.id;
      setPages(menuAdmin(adminMenu, unit));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerFilters?.units?.id, headerFilters?.companies?.id, adminMenu]);

  const handlePermissions = (menu, unit) => {
    const arrayMenu = {
      //home: 'Home',
      dashboard: 'Dashboard',
      planosGerais: 'Planos Gerais',
      relatorios: 'Relatórios',
      geolocalizacao: 'Geolocalização',
      agenda: 'Agenda',
    };
    const filteredJson = menu.find(obj => obj.unidade === (unit !== undefined && unit !== null ? unit : 0));
    const extractedValues = {};
    if (filteredJson === undefined) {
      return;
    }
    const processSubMenu = subMenu => {
      subMenu?.forEach(subItem => {
        const foundKey = Object.keys(arrayMenu).find(key => arrayMenu[key] === subItem.nome);
        if (foundKey) {
          extractedValues[foundKey] = subItem.acesso;
        }
      });
    };
    filteredJson?.menu?.forEach(menuItem => {
      if (menuItem.subMenu && menuItem.subMenu.length > 0) {
        processSubMenu(menuItem.subMenu);
      }

      const foundKey = Object.keys(arrayMenu).find(key => arrayMenu[key] === menuItem.nome);
      if (foundKey) {
        extractedValues[foundKey] = menuItem.acesso;
      }
    });
    extractedValues.dashboard = true;
    return extractedValues;
  };
  const [subMenusAreOpen, setSubMenusAreOpen] = useState({});
  useEffect(() => {
    Object.keys(pages)?.map(key => {
      const categories = pages[key];

      categories?.forEach(category => {
        if (category.children != null || category.children != undefined) {
          setSubMenusAreOpen(prevSubMenus => ({
            ...prevSubMenus,
            [category.label]: false,
          }));
        }
      });
    });
  }, [pages]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef?.current && !menuRef?.current.contains(event.target)) {
        setIsSubMenuOpen(false);
        return;
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => document.removeEventListener('click', handleClickOutside);
  }, [setIsSubMenuOpen]);

  return (
    <>
      <Sidebar ref={menuRef} isOpen={globalComponentsContext?.isMobileMenuOpen}>
        <SidebarContainer ref={menuRef}>
          <Logo>
            {logoPath && <img src={`${process.env.REACT_APP_URL_IMAGES}/${logoPath}`} alt="Logo" />}

            {!logoPath && <img src={leankeepLogoCarbon} alt="Logo" />}
          </Logo>
          <MenuItems>
            {pages &&
              Object.keys(pages)?.map((key, index) => {
                const categories = pages[key];
                return (
                  <StyledMenuCategory key={index}>
                    {categories?.map(category => {
                      const value = v4();
                      return (
                        <CategoryItem
                          subMenusAreOpen={subMenusAreOpen}
                          setSubMenusAreOpen={setSubMenusAreOpen}
                          setIsSubMenuOpen={setIsSubMenuOpen}
                          key={category.label}
                          category={category}
                          index={value}
                        />
                      );
                    })}
                  </StyledMenuCategory>
                );
              })}
          </MenuItems>
        </SidebarContainer>
      </Sidebar>
      <Toast toastList={toastList} autoDelete dismissTime={5000} />
    </>
  );
});
